// extracted by mini-css-extract-plugin
export var container = "mdx-module--container--d7b97";
export var content = "mdx-module--content--7121b";
export var header = "mdx-module--header--b7ea5";
export var linkGlossary = "mdx-module--linkGlossary--2a926";
export var onThisPage = "mdx-module--onThisPage--2cb60";
export var sidebar = "mdx-module--sidebar--a2bab";
export var sidebarContainer = "mdx-module--sidebarContainer--cfca0";
export var summary = "mdx-module--summary--cd1e2";
export var title = "mdx-module--title--0a109";
export var withSidebar = "mdx-module--withSidebar--ef8d9";
export var withTOC = "mdx-module--withTOC--addd4";